import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from 'util/axios';

import { useNavigate, useLocation } from "react-router-dom";

import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";

import { useTranslation } from "react-i18next";

import { userAuthCF } from "util";

const Login = () => {
    const { t } = useTranslation(["page"]);
    const oktaLoginBtn = useRef(null);
    const { oktaAuth, authState } = useOktaAuth();

    const [inputs, setInputs] = useState({
        userId: null,
        password: null,
    });

    const { userId, password } = inputs;

    const navigate = useNavigate();
    const location = useLocation();

    const [incorrect, setIncorrect] = useState(false);

    const userSelector = useSelector((store) => store.user);

    const onChange = (e) => {
        setIncorrect(false);
        const { value, name } = e.target;
        setInputs((i) => ({
            ...i,
            [name]: value,
        }));
    };

    const dispatch = useDispatch();

    const loginValidate = () => {
        return !!userId && !!password;
    };

    const login = async () => {
        if (!loginValidate()) {
            setIncorrect(true);
            return;
        }
        try {
            const response = await axios
                .post(process.env.REACT_APP_API + "/user/userLogin", {
                    userId,
                    password,
                })
                .then((Response) => Response.data.data.result)
                .catch((e) => {
                    window.alert("Login Error");
                    throw new Error(e);
                });
            if (response) {
                let { userId, userNm, userAuth } = response;
                try {

                    userAuth = JSON.parse(userAuth);
                    dispatch({ type: "LOGIN", userId, userNm, userAuth, ...userAuthCF(userAuth), loginType: "own" });
                    navigate("/", { replace: true });
                } catch (e) {
                    window.location.replace("/noauth")
                }

            } else {
                setIncorrect(true);
            }
        } catch (e) {
            console.error(e);
        }
    };


    const loginCheck = async () => {
        dispatch({ type: "LOADING_ON" });
        const response = await axios
            .post(process.env.REACT_APP_API + "/user/loginCheck")
            .then((Response) => Response.data.data.result)
            .catch((e) => console.error(e));
        if (response) {
            let { userId, userNm, userAuth } = response;
            userAuth = JSON.parse(userAuth);
            dispatch({ type: "LOGIN", userId, userNm, userAuth, ...userAuthCF(userAuth), loginType: "own" });

            window.location.replace("/");
        }
        dispatch({ type: "LOADING_OFF" });
    };

    const enter = (e) => {
        if (e.keyCode === 13) {
            login();
        }
    };

    return (
        <div className="login_main">
            <div className="login_window">
                <div className="top">
                    <h1 className="login_text">Login</h1>
                </div>

                <div className="middle">
                    <div className="info">
                        <div className="cf form">
                            <div className="row">
                                <label htmlFor="ID">ID</label>
                                <input
                                    onChange={onChange}
                                    onKeyUp={enter}
                                    type="text"
                                    name="userId"
                                    className="text-field login"
                                    placeholder={t("insertId")}
                                />
                            </div>
                            <div className="row">
                                <label htmlFor="Password">Password</label>
                                <input
                                    onChange={onChange}
                                    onKeyUp={enter}
                                    type="password"
                                    name="password"
                                    className="text-field pass"
                                    placeholder={t("insertPW")}
                                />
                            </div>
                            <div className={"err " + (incorrect ? "" : "no")}>Login Failed!</div>
                            <div className="row">
                                <button onClick={login} className="submit-btn">
                                    LOGIN
                                </button>
                            </div>
                            {/* <div className="row">
                                <button onClick={oktaLogin} className="submit-btn" ref={oktaLoginBtn}>
                                    OKTA SSO LOGIN
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="bottom">
                    <div className="notice">
                        <p>{t("askAdmin")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
